type IntroStorage = Pick<Storage, 'getItem' | 'setItem'>;

/** Claim before starting presentation so reloads and duplicate snapshots never replay it. */
export class MatchIntroHistory {
  private seen = new Set<string>();
  constructor(private storage: () => IntroStorage = () => globalThis.localStorage) {}
  claim(matchId: string, version: number, status: string): boolean {
    if (version !== 1 || status !== 'active' || this.seen.has(matchId)) return false;
    this.seen.add(matchId);
    try {
      const storage = this.storage(), key = `dbz-match-intro-v1:${matchId}`;
      if (storage.getItem(key)) return false;
      storage.setItem(key, 'seen');
    } catch { /* An unavailable browser store still has per-window replay protection. */ }
    return true;
  }
}
